<div class="page-layout blank fullwidth p-12"  style="height: 1px; overflow-y: scroll; padding: 0 !important;   top: 1px;z-index: 9;">
  <div class="surance-details">
    <!-- Header -->
    <div class="header">
      <h3>Request Details</h3>
      <span class="claim-id" *ngIf = "claimNo" >CLM-{{ claimNo }}</span>
    </div>

    <!-- Claim Summary -->
    <div class="summary-card">
      <div class="summary-header">
        <div class="icon-and-claim-summary-cls">
          <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.35476 8.63354H9.35476M4.35476 11.9669H9.35476M11.0214 16.1335H2.68809C2.24606 16.1335 1.82214 15.9579 1.50958 15.6454C1.19702 15.3328 1.02142 14.9089 1.02142 14.4669V2.80021C1.02142 2.35818 1.19702 1.93426 1.50958 1.6217C1.82214 1.30914 2.24606 1.13354 2.68809 1.13354H7.34309C7.56409 1.13359 7.77601 1.22142 7.93226 1.37771L12.4439 5.88938C12.6002 6.04562 12.688 6.25755 12.6881 6.47854V14.4669C12.6881 14.9089 12.5125 15.3328 12.1999 15.6454C11.8874 15.9579 11.4635 16.1335 11.0214 16.1335Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <h4>Claim Summary</h4>
        </div>
        <!-- Toggle button -->
        <div class="view-details-and-icon" (click)="toggleDetails()">
          <button class="view-btn">
            {{ showDetails ? 'Hide Details' : 'View Details' }}
          </button>
          <mat-icon>keyboard_arrow_down</mat-icon>
        </div>
      </div>
    </div>

    <!-- Quote Summary (only when approved tab is active) -->
    <!-- First Quote Summary Card (Updated UI) -->
    <div class="quote-summary-box" *ngIf="activeTab === 'approved' && approvedItemsCount > 0">
      <div class="quote-summary-header">
        <h4>Quote Summary</h4>
        <span class="items-approved">{{ approvedItemsCount }} items approved</span>
      </div>

      <div class="quote-summary-content">
        <div class="summary-row">
          <span>Total MRP</span>
          <span class="value">₹{{ quoteSummary.totalMRP | number:'1.2-2' }}</span>
        </div>
        <div class="summary-row">
          <span>Total Selling Price</span>
          <!-- <span class="value">₹{{ quoteSummary.totalSellingPrice }}</span> -->
           <span class="value">₹{{ quoteSummary.totalSellingPrice | number:'1.2-2' }}</span>
        </div>
        <hr />
        <div class="summary-row total-savings">
          <div class="summary-row-total-savings-small-div">Total Savings</div>
          <span class="savings-value">₹{{ quoteSummary.totalSavings | number:'1.2-2' }}</span>
        </div>
      </div>
    </div>

    <!-- Second Quote Summary Card (Unchanged) -->
  <!-- <div class="no-approve-quote" *ngIf="activeTab === 'approved' && approvedItemsCount === 0"> -->
    <div class="no-approve-quote" *ngIf="activeTab === 'approved' && (!approvedItemsCount || approvedItemsCount === 0)">
    <div class="no-items-card">
      <div class="no-item-img">📋</div>
      <h4>No approved items yet</h4>
      <p>Approve items from the Quote Received tab to see them here.</p>
      <button class="go-btn" (click)="setActiveTab('received')">Go to Quote Received</button>
    </div>
  </div>
  <div class="no-approve-quote" *ngIf="activeTab === 'received' && receivedItemsCount === 0">
    <div class="no-items-card">
      <div class="no-item-img">📋</div>
      <h4>No received items yet</h4>
      <!-- <p>Approve items from the Quote Received tab to see them here.</p> -->
      <button class="go-btn" (click)="setActiveTab('approved')">Go to Quote Approved</button>
    </div>
  </div>

    <!-- Accordion Section -->
    <!-- <div class="accordion-section" [class.open]="showDetails">
      <div class="claim-info">
        <div class="clain-infor-header-and-descrp">
          <h4>Claim Information</h4>
          <p class="subtitle">Complete details for your insurance claim</p>
        </div>
        <div class="info-card" *ngIf="spareQuotation">
          <h5>🚗 Vehicle Information</h5>
          <div class="row">
            <div class="box">
              <p class="label">Vehicle Type</p>
              <p class="value">Passenger Car</p>
            </div>
            <div class="box">
              <p class="label">Make & Model</p>
              <p class="value">{{ spareQuotation.make }} {{ spareQuotation.model }}</p>
            </div>
          </div>
          <div class="row">
            <div class="box">
              <p class="label">Fuel & Variant</p>
              <p class="value">{{ spareQuotation.fuelType }} {{ spareQuotation.variant }}</p>
            </div>
            <div class="box">
              <p class="label">Year</p>
              <p class="value">{{ spareQuotation.manufacturingYear }}</p>
            </div>
          </div>
          <div class="row-variant-vin">
            <div class="box-red">
              <p class="label-reg">Registration Number</p>
              <p class="value-reg">{{ spareQuotation.regNo }}</p>
            </div>
            <div class="box-green">
              <p class="label-vin">VIN Number</p>
              <p class="value-num">{{ spareQuotation.vinNo }}</p>
            </div>
          </div>
        </div>

        <div class="info-card" *ngIf="spareQuotation">
          <h5>🛡️ Insurance Details</h5>
          <div class="row-insurance-details">
            <div class="box-insurance-details">
              <p class="label">Claim Type</p>
              <p class="value">{{ claimType }}</p>
            </div>
            <div class="box-insurance-details">
              <p class="label">Claim Number</p>
              <p class="value">{{ claimNo }}</p>
            </div>
          </div>
        </div>

        <div class="info-card">
          <h5>👨‍💼 Surveyor Contact</h5>
          <div class="surveyinfo-card">
            <div class="survey-name-and-name">
              <p class="label">Surveyor Name</p>
              <p class="value">{{ surveyor }}</p>
            </div>
            <div class="survey-mbl-and-mbl">
              <p class="label">Mobile Number</p>
              <p class="value highlight"> 📞 {{ surveyorContact }}</p>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- backdrop (click outside to close) -->
  <div *ngIf="showDetails" class="sheet-backdrop" (click)="closeSheet()"></div>

  <!-- bottom sheet -->
  <div
    class="accordion-section bottom-sheet"
    [class.open]="showDetails"
    tabindex="-1"
    (keydown.escape)="closeSheet()"
  >
    <div class="claim-info">
      <!-- header (same class name you have + sheet-header) -->
      <div class="clain-infor-header-and-descrp sheet-header">
        <!-- close icon (keeps visual small round X like your screenshot) -->
        <button type="button" class="sheet-close" aria-label="Close" (click)="closeSheet()">✕</button>

        <h4>Claim Information</h4>
        <p class="subtitle">Complete details for your insurance claim</p>
      </div>

      <!-- scrollable content — put your original .info-card blocks here -->
      <div class="sheet-body">
        <!-- Vehicle Information -->
        <div class="info-card" *ngIf="spareQuotation">
          <h5>🚗 Vehicle Information</h5>
          <div class="row">
            <div class="box">
              <p class="label">Vehicle Type</p>
              <p class="value">Passenger Car</p>
            </div>
            <div class="box">
              <p class="label">Make & Model</p>
              <p class="value">{{ spareQuotation.make }} {{ spareQuotation.model }}</p>
            </div>
          </div>

          <div class="row">
            <div class="box">
              <p class="label">Fuel & Variant</p>
              <p class="value">{{ spareQuotation.fuelType }} {{ spareQuotation.variant }}</p>
            </div>
            <div class="box">
              <p class="label">Year</p>
              <p class="value">{{ spareQuotation.manufacturingYear }}</p>
            </div>
          </div>

          <div class="row-variant-vin">
            <div class="box-red">
              <p class="label-reg">Registration Number</p>
              <p class="value-reg">{{ spareQuotation.regNo }}</p>
            </div>
            <div class="box-green">
              <p class="label-vin">VIN Number</p>
              <p class="value-num">{{ spareQuotation.vinNo }}</p>
            </div>
          </div>
        </div>

        <!-- Insurance Details -->
        <div class="info-card" *ngIf="spareQuotation && claimNo">
          <h5>🛡️ Insurance Details</h5>
          <div class="row-insurance-details">
            <div class="box-insurance-details" *ngIf="claimType">
              <p class="label">Claim Type</p>
              <p class="value">{{ claimType }}</p>
            </div>
            <div class="box-insurance-details" *ngIf="claimNo">
              <p class="label">Claim Number</p>
              <p class="value">{{ claimNo }}</p>
            </div>
          </div>
        </div>

        <!-- Surveyor Contact -->
        <div class="info-card" *ngIf="surveyor || surveyorContact">
          <h5>👨‍💼 Surveyor Contact</h5>
          <div class="surveyinfo-card">
            <div class="survey-name-and-name" *ngIf="surveyor">
              <p class="label">Surveyor Name</p>
              <p class="value">{{ surveyor }}</p>
            </div>
            <div class="survey-mbl-and-mbl" *ngIf="surveyorContact">
              <p class="label">Mobile Number</p>
              <p class="value highlight">📞 {{ surveyorContact }}</p>
            </div>
          </div>
        </div>

        <!-- repeat any remaining original blocks here -->
      </div>
    </div>
  </div>

    <!-- SECODN-SECTION==================== -->
    <!-- Tabs -->
    <!-- <div class="status-tabs sticky-tabs"> -->
      <div class="status-tabs sticky-tabs" *ngIf="(activeTab === 'approved' && approvedItemsCount > 0) || (activeTab === 'received' && receivedItemsCount > 0)">
    <!-- <div class="status-tabs sticky-tabs" *ngIf="approvedItemsCount > 0 || receivedItemsCount > 0"> -->
        <div class="status" [class.active]="activeTab === 'received'" (click)="setActiveTab('received')">
          <!-- <span class="icon">✅</span> -->
          <span class="icon" style="color: #28a745; font-size: 18px;">✅</span> <!-- green check -->

          <span>
            QUOTE RECEIVED<br />
            <small>{{ receivedItemsCount }} items</small>
          </span>
        </div>

        <div class="status quote-approved" [class.active]="activeTab === 'approved'" (click)="setActiveTab('approved')">
          <!-- <span class="icon">⏳</span> -->
          <span class="icon" style="color: #12497A; font-size: 18px;">⏳</span> <!-- blue hourglass -->

          <span>
            QUOTE APPROVED<br />
            <small>{{ approvedItemsCount }} items</small>
          </span>
        </div>
    </div>
    <div class="rcvd-cnt" *ngIf="activeTab === 'received' && receivedItemsCount > 0">
    📋 Quote received for {{ receivedItemsCount }} {{ receivedItemsCount === 1 ? 'item' : 'items' }}
    </div>

    <div class="apprvd-cnt" *ngIf="activeTab === 'approved' && approvedItemsCount > 0">
      📋 Quote approved for {{ approvedItemsCount }} {{ approvedItemsCount === 1 ? 'item' : 'items' }}
    </div>


    <!-- Select Items -->
    <!-- Received tab -->
    <div class="select-all"
        *ngIf="activeTab === 'received' && receivedItemsCount > 0">
      <label>
        <input class="checkbox"
              type="checkbox"
              [(ngModel)]="selectAllReceived"
              (change)="toggleSelectAllReceived()" />
        <!-- <div  style="color: #000000; font-size: 18px;">📋</div> -->
        <div style="display: inline;">
          <span class="select-all-txt" >Select All Items</span>
          <div class="choose-all" >Choose all parts for approval</div>
        </div>
      </label>
      <div class="txt-text-wth-amnt">
        <!-- <span class="total">₹ {{ totalReceivedAmount.toFixed(2) }}</span> -->
        <span class="total">₹ {{ totalReceivedAmountAll.toFixed(2) }}</span>
        <span class="total-txt">Total MRP Price</span>
      </div>
    </div>

    <!-- Approved tab -->
    <div class="select-all"
        *ngIf="activeTab === 'approved' && approvedItemsCount > 0 ">
      <label>
        <input class="checkbox"
              type="checkbox"
              [(ngModel)]="selectAllApproved"
              (change)="toggleSelectAllApproved()" />
        <!-- <div style="color:#12497A;; font-size: 18px;">📋</div> -->
        <span  class="select-all-txt">Select All Items</span>
      </label>
      <!-- <span class="total">₹ {{ totalApprovedAmount.toFixed(2) }}</span> -->
      <span class="total">₹ {{ totalApprovedAmountAll.toFixed(2) }}</span>
    </div>

    <!-- Items List -->
    <div class="item-card" 
      *ngFor="let item of filteredItems; let i = index"
      [ngClass]="item.paymentSource ? item.paymentSource.toLowerCase().replace(' ', '-') : 'not-set'">

      <div class="item-header">
        <label>
          <input  class="checkbox" type="checkbox" [(ngModel)]="item.selected" (change)="updateSelection()" />
        </label>
        <div class="item-info">
          <div style="display: flex; align-items: center;">
            <!-- <span class="icon" style="color:#000000">🔧</span> -->
            <p>{{ item.name }}</p>
          </div>
          <!-- Brand & Code pills -->
          <div class="meta-container">
            <p>Qty: {{ item.qty }}</p>
            <!-- <span class="brand-pill" style= "color:#0F2F52">🏭 {{ spareQuotation.make }}</span>
            <span class="code-pill">🔢 {{ spareQuotation.regNo }}</span> -->
          </div>

          <!-- Discount & Date pills -->
          <div class="pill-container">
            <!-- <span class="discount-pill">💰 {{ item.discount }}% OFF</span> -->
            <!-- <span class="discount-pill" *ngIf="item.sellingDiscount">💰 {{ item.sellingDiscount }}% OFF</span> -->
            <!-- <span class="date-pill">⏰ {{ item.date }}</span> -->
          </div>

        </div>

        <!-- Price -->
        <div class="item-price">
          <p class="total-MRP-Price">Total MRP </p>
          <h4>₹ {{ item.mrp * item.qty }}</h4>
          <!-- <div class="available">Total MRP </div> -->
          <span class="date-pill" *ngIf="activeTab === 'received'">⏰ {{ item.date }}</span>
          <!-- <p class="mrp">MRP ₹ {{ item.mrp }}</p> -->
          <!-- Payment Status -->
          <!-- <div class="payment-status" *ngIf="activeTab === 'approved'" >💵
            {{ item.paymentSource ? item.paymentSource : 'Payment Not Set' }}
          </div> -->
          <div class="payment-status" *ngIf="activeTab === 'approved'">💵
            {{ item.paymentSource === 'customerPayment' ? 'Customer Payment' :
              item.paymentSource === 'insuranceCoverage' ? 'Insurance Coverage' :
              'Payment Not Set' }}
          </div>

        </div>
      </div>
    </div>

    <!-- Footer for Received tab -->
    <div class="footer-bar" *ngIf="activeTab === 'received' && receivedItemsCount && selectedReceivedCount > 0 && !showApprovePopup">
      <div class="footer-info">
        <div class="ttl-amt-and-itm-slctd-txt">
          <strong>₹ {{ totalReceivedAmount.toFixed(2) }}</strong>
          <span>{{ selectedReceivedCount }} items selected</span>
        </div>
        <div class="ttl-amnt-text-and-amnt">
          <!-- <div class="ttl-amnt">Total amount</div> -->
              <button class="approve-btn" (click)="approveQuote()">Approve Quote</button>
        </div>
      </div>
    </div>

    <!-- Footer for Approved tab -->
     <!-- *ngIf="activeTab === 'approved' && approvedItemsCount && selectedApprovedCount > 0 && canAssignPayment  && !showPaymentSheet " -->
    <div class="footer-bar-approve" *ngIf="activeTab === 'approved' 
             && approvedItemsCount 
             && selectedApprovedCount > 0 
              && spareQuotationHasNoPO()
             && !showPaymentSheet">
      <div class="footer-info">
        <div class="ttl-amt-and-itm-slctd-txt">
          <strong>₹ {{ totalApprovedAmount.toFixed(2) }}</strong>
          <span>{{ selectedApprovedCount }} items selected</span>
        </div>
        <div class="ttl-amnt-text-and-amnt">
          <!-- <div class="ttl-amnt">Total amount</div> -->
        <button class="approve-btn" 
                (click)="assignPaymentSource()">
          Assign Payment Source
        </button>
        </div>
      </div>
    </div>

    <!-- SECOND-SECTION==================== END -->
    <!-- Payment Source Bottom Sheet -->
    <!-- <div class="overlay" *ngIf="showPaymentSheet" (click)="closePaymentSheet()"></div> -->
    <div *ngIf="showPaymentSheet" class="sheet-backdrop-payment-source" (click)="closePaymentSheet()"></div>
    <div class="payment-bottom-sheet-quote-aprv" *ngIf="showPaymentSheet">
      <div class="sheet-content">
        <h3>Assign Payment Source</h3>
        <p>Select payment method for {{ selected }} selected items</p>

        <div  class="payment-option"   [class.active]="selectedPayment === 'insurance'"   (click)="selectedPayment = 'insurance'"   >
          <div class="icon"  style="color: #144579;">🛡️</div>
          <div class="info">
            <h4>Insurance Coverage</h4>
            <p>Covered under policy</p>
          </div>
          <div class="check" *ngIf="selectedPayment === 'insurance'">✔</div>
        </div>

        <div  class="payment-option"   [class.active]="selectedPayment === 'customer'" (click)="selectedPayment = 'customer'"  >
          <div class="icon" style="color: #144579;">💳</div>
          <div class="info">
            <h4>Customer Payment</h4>
            <p>Direct customer payment</p>
          </div>
          <div class="check" *ngIf="selectedPayment === 'customer'">✔</div>
        </div>
        <!-- Footer buttons -->
        <div class="sheet-footer">
          <button class="cancel-btn" (click)="closePaymentSheet()">Cancel</button>
          <button class="assign-btn" (click)="assignPaymentNew()">Assign Payment</button>
        </div>
      </div>
    </div>
  </div>
  <!-- Approve Quote Popup -->
  <div class="approve-popup" *ngIf="showApprovePopup">
    <div class="popup-content">
      <span class="claim-id">{{ claimNo }}</span>
      <div class="icon-wrapper">
        <mat-icon  class="icon">check</mat-icon>
      </div>
      <h3>Quote Approved</h3>
      <p>Items moved to Quote Approved. Next, assign the payment source.</p>
      <button class="go-btn" (click)="goToQuoteApproved()">Go to Quote Approved</button>

      <div class="next-steps">
        <p>What happens next?</p>
        <div class="ol-with-num">
          <ol>
            <li>Payment source will be assigned</li>
            <li>Parts will be ordered and delivered</li>
            <li>Repair work can begin</li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</div>
